module.exports = __webpack_public_path__ + "img/07.9a4bf39d.png";